import React from "react";
import useTranslation from "../../../../hooks/useTranslation";
import Button from "../../../styled-UI/Button";
import CustomText from "../../../styled-UI/CustomText";
import Popup from "../../../styled-UI/Popup";
import styled from "styled-components/macro";

interface Props {
  onClose: () => void;
  isOpen: boolean;
  onAccept: () => void;
}

const ADTLegalDisclaimerPopup = ({ onClose, isOpen, onAccept }: Props): JSX.Element => {
  const { translateLabel } = useTranslation();

  return (
    <>
      <Popup
        isOpen={isOpen}
        close={onClose}
        isFullSize={false}
        widthPx={1220}
        customPaddingContent="0"
        customPaddingHeader="0 2rem"
        customHeightHeader="5rem"
        customIconType="no-background-primary"
      >
        <Container>
          <ContentWrapper>
            <CustomText
              as="h1"
              fontSizePx={32}
              lineHeightPx={32}
              color="primary"
              font="font-medium"
              marginBottomPx={100}
              {...{ justifyContent: "center" }}
            >
              {translateLabel("ADT_RPI_TITLE_PRODUCT_IMAGES")}
            </CustomText>
            <CustomText
              as="h2"
              fontSizePx={24}
              marginBottomPx={40}
              lineHeightPx={24}
              font="font-medium"
              color="primary"
              {...{ justifyContent: "center" }}
            >
              {translateLabel("ADT_LEGAL_DISCLAIMER_TITLE")}
            </CustomText>
            <CustomText
              as="p"
              fontSizePx={14}
              lineHeightPx={24}
              whiteSpace={"pre-line"}
              font="font-regular"
            >
              {translateLabel("ADT_LEGAL_DISCLAIMER_CONTENT")}
            </CustomText>
          </ContentWrapper>
          <ButtonWrapper>
            <Button type="primary" onClick={onAccept}>
              {translateLabel("ADT_LEGAL_DISCLAIMER_BUTTON_LABEL")}
            </Button>
          </ButtonWrapper>
        </Container>
      </Popup>
    </>
  );
};

const Container = styled.div`
  width: 100%;
  height: auto;
`;

const ContentWrapper = styled.div`
  padding: 0 4.063rem 5rem 4.063rem;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.5rem 3rem;
  background-color: ${(props) => props.theme.palette.white};
  border: solid 1px ${(props) => props.theme.palette.gray.borders};
  height: 6.25rem;
`;

export default ADTLegalDisclaimerPopup;
